module.exports = __webpack_public_path__ + "static/Дьячковская НЕ.jpg";